import React from 'react';
import PropTypes from 'prop-types';
import { SocialWrapper, ContentWrap, StyledIcon } from './styles/ButtonStyled';

const SocialButton = ({ icon, align, iconSize, iconColor, separation, ...props }) => (
  <SocialWrapper {...props} iconType={icon}>
    <ContentWrap align={align}>
      <StyledIcon separation={separation} name={icon} color={iconColor} size={iconSize} />
    </ContentWrap>
  </SocialWrapper>
);

SocialButton.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  type: PropTypes.string,
  align: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  separation: PropTypes.number,
};

SocialButton.defaultProps = {
  icon: '',
  text: '',
  type: '',
  align: '',
  iconSize: 24,
  iconColor: 'white',
  separation: null,
};

export default SocialButton;
